import { serviceLoading } from 'common/loaderReducer';
import Loader from 'components/Loader';
import * as React from 'react';
import * as _ from 'lodash';
import { InLine, CheckContainer } from './styles';
import { Title, BodyTextCenter, BodyTextLeft,DescriptionContainer, BottomTextContainer, ButtonContainer } from '../Upsell/styles';
import { ModalUpsell }  from '../Upsell';
import { KEYS } from 'common/constants';
import delayUnmounting from 'features/Dealers/DealerConfiguration/Modals/delayUnmounting';
import ActionBar from 'components/ActionBar';
import { getUrlUpgradeAPI } from './state/actions';
import upsellupgrade from './upsellupgrade.svg';
import check from './check.svg';
import { GET_URLUPGRADE_API_REQUEST } from './state/actionTypes';
import { TCButton } from 'components/TCButton';
import { TC_BUTTON_TYPE } from 'components/TCButton/constants';
import { RootState } from 'store/types';
import { connect } from 'react-redux';
import { WebsiteProvider } from 'features/Dealers/DealerSelect/state/types';

export interface ModalUpsellUpgradeProps {
    shouldShow: boolean;
    websiteProvider: WebsiteProvider;
    dealerId?: string;
    url?: string;
    UrlUpgradeAPI?: (dealerId?: string) => {};
    isRequesting?: boolean;
}

export interface ModalUpsellUpgradeStates {
}

class ModalUpsellUpgrade extends React.Component<ModalUpsellUpgradeProps, ModalUpsellUpgradeStates> {
    constructor(props) {
        super(props);
    }

    componentWillMount(){
        if (this.props.UrlUpgradeAPI) this.props.UrlUpgradeAPI(this.props.dealerId);
    }

    onUpgradeClick = () => {
        window.location.href=this.props.url??'';
    }

    keyDownHandle = (e) => {
        if (e.key === KEYS.ENTER) {
            this.onUpgradeClick()
        }
    }

    render() {
        return (
            <ModalUpsell shouldShow={this.props.shouldShow}>
                <Title>
                    Listings Manager
                </Title>
                <DescriptionContainer>
                    <BodyTextCenter>
                        Manage your local listings from one place
                    </BodyTextCenter>
                </DescriptionContainer>
                <img src={upsellupgrade} style={{width: 'auto'}}/>
                <BottomTextContainer>
                    <InLine>
                        <CheckContainer/>
                        <BodyTextLeft>
                            Automatically update your business profile from our CMS
                        </BodyTextLeft>
                    </InLine>
                    <InLine>
                        <CheckContainer/>
                        <BodyTextLeft>
                            Apply ${this.props.websiteProvider.displayName}'s best practice on your listings
                        </BodyTextLeft>
                    </InLine>
                    <InLine>
                        <CheckContainer/>
                        <BodyTextLeft>
                            Publish your specials to Google Business Profile with the click of a button
                        </BodyTextLeft>
                    </InLine>
                    <InLine>
                        <CheckContainer/>
                        <BodyTextLeft>
                            Easily view the performance of your GBP listings and posts
                        </BodyTextLeft>
                    </InLine>
                </BottomTextContainer>
                <ButtonContainer>
                {
                    this.props.isRequesting &&
                    <Loader/>
                }
                {
                    !this.props.isRequesting &&
                    <TCButton
                        type={TC_BUTTON_TYPE.PRIMARY}
                        onClick={this.onUpgradeClick}
                    >
                        UPGRADE TODAY
                    </TCButton>
                }
                </ButtonContainer>
            </ModalUpsell>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    dealerId: state.dealers.dealer.selectedDealer?.id,
    url: state.dealers.urlUpgrade.url,
    isRequesting: serviceLoading(state, [GET_URLUPGRADE_API_REQUEST])
});

const mapDispatchToProps = (dispatch) => ({
    UrlUpgradeAPI: (dealerId: string) => dispatch(getUrlUpgradeAPI(dealerId))
});

export default delayUnmounting<ModalUpsellUpgradeProps>(connect(mapStateToProps,mapDispatchToProps)(ModalUpsellUpgrade));
